import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConnectivtyBannerService } from './connectivty-banner.service';

@Injectable()
export class ConnectivityInterceptorService implements HttpInterceptor {
  private readonly bannerService = inject(ConnectivtyBannerService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const apiPath = environment.apiPath.replace(/\/$/, '');
    if (req.url !== apiPath && !req.url.startsWith(`${apiPath}/`)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.bannerService.requestSucceeded();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.bannerService.requestFailed();
        return throwError(() => error);
      }),
    );
  }
}
